import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { CategoryDistribution } from '../../../types/dashboard';

interface CategoryPieChartProps {
  data: CategoryDistribution[];
}

const DEFAULT_COLORS = ['#38bdf8', '#a78bfa', '#34d399', '#fbbf24', '#94a3b8', '#f472b6', '#fb923c'];

const CustomTooltip = ({ active, payload }: any) => {
  if (!active || !payload?.length) return null;
  const data = payload[0];
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg p-3">
      <p className="text-xs font-semibold text-slate-300">{data.name}</p>
      <p className="text-xs text-slate-400">{data.value} complaints ({data.payload.percentage}%)</p>
    </div>
  );
};

export const CategoryPieChart: React.FC<CategoryPieChartProps> = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={250}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={90}
          paddingAngle={3}
          dataKey="count"
          nameKey="category_name"
        >
          {data.map((_, index) => (
            <Cell key={index} fill={DEFAULT_COLORS[index % DEFAULT_COLORS.length]} />
          ))}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
        <Legend
          wrapperStyle={{ fontSize: 11 }}
          formatter={(value: string) => <span className="text-slate-300">{value}</span>}
        />
      </PieChart>
    </ResponsiveContainer>
  );
};
